import { channelClient, RequestPolicies } from 'shared/channels';
import type { Finances } from 'shared/types/analytics';
import { analyticsContract } from './analyticsContract';
import type { AnalyticsChart, ChartRequest, ChartResult } from './chartModel';

/** Charts and financial data as calculated by the service worker. */
export const analyticsClient = {
  /** May wait for the first download of issues or inspections. */
  async getChart<TChart extends AnalyticsChart>(request: ChartRequest<TChart>): Promise<ChartResult<TChart>> {
    const result = await channelClient.request(analyticsContract, 'getChart', request, RequestPolicies.bulkRead);
    // The worker calculates the series of the requested chart (ChartSeriesByChart).
    return result as ChartResult<TChart>;
  },

  getFinancialData(): Promise<Finances> {
    return channelClient.request(analyticsContract, 'getFinancialData', undefined, RequestPolicies.bulkRead);
  },
};
